import * as Yup from 'yup';

export const groupFormSchema = Yup.object().shape({
  serviceGroupName: Yup.string().required('Name is required'),
});
